<template>
    <ArtistSection
        v-bind="filters"
        :color-theme="colorTheme"
    >
        <template #title>
            {{ props.title }}
        </template>
    </ArtistSection>
</template>

<script setup lang="ts">
import type { FlexibleArtistBlockFragment } from '~/types/craft-schema';

const props = defineProps<FlexibleArtistBlockFragment>();

const filters = useExtractFiltersFromCraftBundle(props.artistBundle?.[0]);
</script>
